<template>
  <span>
    <template v-if="hasValidReferenceId">
      because of product
      <router-link
        class="product-id-link"
        target='_blank'
        :to="{ name: ProductsEnum.ProductDetails, params: { productId: referenceId } }"
      >
        {{ referenceId }}
      </router-link>
    </template>
    <template v-else>
      please review
      <router-link
        class="product-id-link"
        target='_blank'
        :to="{ name: OrdersEnum.OrdersWithView, params: { view: 'On Hold' } }"
      >
        here
      </router-link>
    </template>
  </span>
</template>

<script>
import { ProductsEnum, OrdersEnum } from '@/enums/modules/routes'

export default {
  name: 'ProductIdLink',
  props: {
    referenceId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    ProductsEnum,
    OrdersEnum
  }),
  computed: {
    hasValidReferenceId () {
      return this.referenceId > 0
    }
  }
}
</script>

<style lang='scss'>
@import '../../../../assets/scss/shipbob-custom/_mixins.scss';
.product-id-link {
  @include link;
}
</style>
